import { createFromProduct, ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import {
    createHandlerChainRunner,
    executeAwaitableHandlerChain,
    Handler,
    HandlerProps
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { Category } from "@insite/client-framework/Services/CategoryService";
import { getProductById, GetProductByIdApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import getRealTimeWarehouseInventory from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import { CartLineModel, OrderLineModel, ProductInventoryDto, ProductModel, ProductPriceDto, WarehouseDto } from "@insite/client-framework/Types/ApiModels";
import { productClickTracking } from "@MasterBluePrint/tracking";


export interface GetInventoryByIdParameter {
    productId: string;
    listType: string;
    unitOfMeasure: string;
    product: CartLineModel | ProductContextModel | OrderLineModel;
    currentPageUrl: string;
    carouselTitle: string,
    category: Category | undefined,
    itemLinkClick: string | undefined
}

type Parameter = GetInventoryByIdParameter;
interface DataLayerData {
    name: string;
    id: string;
    price: number;
    brand: string;
    category: string;
    list: string;
    position: number;
    stock: string;
    stockqty: number;
    vendorstockstatus: string,
    vendorstockqty: number
}
interface Props {
    parameter: GetInventoryByIdParameter;
    products?: ProductModel[];
    productInfos?: ProductInfo[];
    dataLayerData?: DataLayerData[];
    product: CartLineModel | ProductContextModel | OrderLineModel;
    carouselTitle: string;
    carouselType: string;
    category: Category | undefined;
    currentPageUrl: string;
    warehouses: WarehouseDto[] | undefined;
    inventory?: ProductInventoryDto;
    itemLinkClick: string | undefined;
}
type HandlerType = Handler<Parameter, Props>;



export const LoadInventory: HandlerType = props => {

    const parameter = props.parameter;
    if (!parameter) {
        return false;
    }

    const productId = parameter.productId;
    const carouselTitle = parameter.carouselTitle;
    const currentPageUrl = parameter.currentPageUrl;
    const product = parameter.product;
    const listType = parameter.listType;
    const category = parameter.category;
    const unitOfMeasure = parameter.unitOfMeasure;
    const itemLinkClick = parameter.itemLinkClick;

    if (currentPageUrl === "/Cart" || currentPageUrl === "/MyAccount/Orders/Details" || currentPageUrl === "/MyAccount/Rfq/Quote/QuoteDetail") {
        if (productId) {
            props.dispatch(getRealTimeWarehouseInventory({
                productId: parameter.productId,
                unitOfMeasure,
                expand: ["warehouses"],
                onComplete: result => {
                    props.inventory =  (result as typeof result & { inventory? : ProductInventoryDto }).inventory;
                    props.warehouses = result.warehouses;
                    productClickTracking(product, carouselTitle, listType, category, currentPageUrl, props.getState(), props.warehouses, props.inventory, itemLinkClick);
                },
            })
            );
        }
    } else {
        productClickTracking(product, carouselTitle, listType, category, currentPageUrl, props.getState(), props.warehouses, props.inventory, itemLinkClick);
    }

};


export const chain = [LoadInventory];

const loadInventoryForDataLayer = createHandlerChainRunner(chain, "LoadProductForDataLayer");

export default loadInventoryForDataLayer;
